import axios from "axios";

import { toast } from "react-toastify";
import API from "Services/Api";
import { Schedule } from "Pages/Schedule/components/ValidationRangeCep/interface";
import {
  CollectRangeCepAPI,
  CollectRangeCepParams,
  ScheduleByRangeCep,
} from "./interface";

const BASE_URL = process.env.REACT_APP_MS_API_URL;

export async function getCollectRangeCep({ zip_code }: CollectRangeCepParams) {
  try {
    const data = await axios.get<CollectRangeCepAPI>(
      `${BASE_URL}/site/home-collection/availability/zipcode`,
      {
        params: {
          zip_code,
          origin: process.env.REACT_APP_URL_COLABI,
        },
      }
    );

    return { data };
  } catch (error: any) {
    if (error.response) {
      const { status, data } = error.response;

      // Tratamento de erro 404
      if (status === 404) {
        toast.error(data.message);
      }

      // Tratamento de erro 500
      if (status === 500) {
        toast.error(
          "Ocorreu um erro ao verificar se o seu CEP está dentro da área de cobertura."
        );
      }
    }
  }
}

export async function getScheduleByRangeCep({
  zip_code,
  origin,
}: ScheduleByRangeCep) {
  try {
    const { data } = await axios.get<CollectRangeCepAPI>(
      `${BASE_URL}/site/home-collection/availability/zipcode`,
      {
        params: {
          zip_code,
          origin,
        },
      }
    );

    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      throw new Error(error?.response?.data?.message);
    }

    if (error?.response?.status === 500)
      throw new Error(
        "Ocorreu um erro ao verificar se o seu CEP está dentro da área de cobertura."
      );

    throw new Error("CEP não encontrado! Verifique se o digitou corretamente.");
  }
}

export const getSchedules = async (cep: string): Promise<Schedule[]> => {
  try {
    const response = await API.get(`calendar_kml/${cep}`);
    return response.data;
  } catch (error: any) {
    if (error?.response?.data?.errors) {
      throw new Error(error?.response?.data?.errors[0].message);
    }

    throw new Error("Não foi possível buscar a agenda disponível");
  }
};
